import SubsectionCard from "../SubsectionCard";

const ContentSection = ({ content }) => {
  const contentRelevance = content["Subsection A - Relevance"];
  return (
    <div className="writingGradeSectionContainer">
      <div className="writingGradeSectionHeaderContainer">
        <h2 className="writingGradeSectionHeader">
          Relevance {content.Score}/20 (30% of total grade){" "}
        </h2>
      </div>
      <div className="writingGradeSectionBodyContainer">
        <SubsectionCard
          title="Content"
          feedbackText={content.Feedback}
          score={`${content.Score}/10`}
        />
        <SubsectionCard
          title="Relevance"
          feedbackText={contentRelevance.Feedback}
          score={`${contentRelevance.Score}/10`}
        />
      </div>
    </div>
  );
};

export default ContentSection;
